import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "../../interfaces/user.type";
import { UserDid } from "../../interfaces/Did.type";

export interface userState {
    allUsers: User[]
    didUsers: UserDid[]
}

const initialState: userState = {
    allUsers: [],
    didUsers: []
};

export const userSlice = createSlice({
    name: "users",
    initialState,
    reducers: {
        setAllUsersSlice: (state, action: PayloadAction<User[]>) => {
            state.allUsers = action.payload;
        },
        setDidUsersSlice: (state, action: PayloadAction<UserDid[]>) => {
            state.didUsers = action.payload;
        },
        addDidUserSlice: (state, action: PayloadAction<UserDid>) => {
            state.didUsers.push(action.payload);
        }
        ,
        deleteDidUserSlice: (state, action: PayloadAction<{
            user_id: string;
            did: string;
        }>) => {
            state.didUsers = state.didUsers.filter(user => !(user.user_id === action.payload.user_id && user.did === action.payload.did));
        },
        updateDidUserSlice: (state, action: PayloadAction<UserDid>) => {
            state.didUsers = state.didUsers.map((user) => user.user_id === action.payload.user_id ? action.payload : user);
        }
    },
});


export const { setAllUsersSlice, setDidUsersSlice, addDidUserSlice, deleteDidUserSlice, updateDidUserSlice } = userSlice.actions;

export default userSlice.reducer;
